module.exports = __webpack_public_path__ + "img/02.b2da7240.png";